// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"279":"d65fd32d","971":"05068d30"}[chunkId] + ".chunk.js";
};